import { LookbookBrand, LookbookDesign } from '@/types/activation/lookbook';

/** A4 portrait at 96dpi — the exact pixel size we rasterize for the PDF. */
export const LOOKBOOK_PAGE_W = 794;
export const LOOKBOOK_PAGE_H = 1123;

const INK = '#15233A';
const MUTED = '#5B6472';

interface LookbookPageFrameProps {
  brand: LookbookBrand;
  design: LookbookDesign;
  index: number;
  total: number;
}

/**
 * One full A4 design page: a co-brand gradient stripe, the centered mockup, and
 * a numbered caption strip. Used both in the in-app gallery (scaled down) and as
 * a rasterized PDF page (rendered at native size).
 */
export const LookbookPageFrame = ({ brand, design, index }: LookbookPageFrameProps) => {
  const { Component } = design;
  return (
    <div
      style={{
        width: LOOKBOOK_PAGE_W,
        height: LOOKBOOK_PAGE_H,
        background: '#F4F7FB',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: 60,
        fontFamily: 'Poppins, system-ui, sans-serif',
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 6, background: 'linear-gradient(90deg, #4E9CFF 0%, #FF4DB8 100%)' }} />

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Component brand={brand} />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, paddingTop: 16, borderTop: '1.5px solid rgba(15,23,42,.12)' }}>
        <div style={{ fontSize: 40, fontWeight: 800, color: brand.secondary, lineHeight: 1, letterSpacing: '-0.02em' }}>
          {String(index).padStart(2, '0')}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 19, fontWeight: 700, color: INK }}>{design.name}</div>
          <div style={{ fontSize: 12.5, color: MUTED, marginTop: 2 }}>{design.meta}</div>
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#fff', background: brand.primary, padding: '6px 12px', borderRadius: 999 }}>
          {brand.name}
        </div>
      </div>
    </div>
  );
};
